/**
 * TerraMatrix Universal Data Platform - SavedQueryChips Component
 *
 * Sprint 5: Frontend - Data Page
 * Created: November 2025
 *
 * Quick access chips for common/saved queries.
 */

import React from 'react';

interface SavedQueryChipsProps {
  onSelect: (query: string) => void;
}

// Default suggestion queries
const DEFAULT_SUGGESTIONS = [
  'Show all active sensors',
  'Average moisture this week',
  'Temperature trends today',
  'List all zones',
  'Compare zones',
];

export const SavedQueryChips: React.FC<SavedQueryChipsProps> = ({ onSelect }) => {
  // In the future, this could fetch saved queries from the API
  const suggestions = DEFAULT_SUGGESTIONS;

  return (
    <div className="flex flex-wrap gap-2 mb-3">
      {suggestions.map((suggestion, i) => (
        <button
          key={i}
          onClick={() => onSelect(suggestion)}
          className="text-xs px-3 py-1.5 bg-muted rounded-full hover:bg-accent
                     transition-colors text-muted-foreground hover:text-foreground"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default SavedQueryChips;
